import { render, staticRenderFns } from "./KpiCardOverview.vue?vue&type=template&id=0bb010d8&scoped=true&lang=html&"
import script from "./KpiCardOverview.vue?vue&type=script&lang=js&"
export * from "./KpiCardOverview.vue?vue&type=script&lang=js&"
import style0 from "./KpiCardOverview.vue?vue&type=style&index=0&id=0bb010d8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb010d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VProgressCircular,VRow,VSelect,VSpacer})
